import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import useAuthStore from '../../store/authStore';

const KVKKBanner = () => {
  const { token } = useAuthStore();
  const [show, setShow] = useState(false);
  const [readMore, setReadMore] = useState(false);

  useEffect(() => {
    if (!token) return;
    if (localStorage.getItem('kvkk_accepted') === '1') return;
    api.get('/kvkk/status').then(r => {
      if (r.data.accepted) localStorage.setItem('kvkk_accepted', '1');
      else setShow(true);
    }).catch(() => setShow(true));
  }, [token]);

  const accept = async () => {
    try {
      await api.post('/kvkk/accept');
      localStorage.setItem('kvkk_accepted', '1');
      setShow(false);
    } catch { alert('Onay kaydedilemedi, tekrar deneyin.'); }
  };

  if (!show) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1f2937', color: '#fff', boxShadow: '0 -4px 20px rgba(0,0,0,0.25)',
      padding: '18px 22px', animation: 'slideUp 0.35s ease-out'
    }}>
      <style>{`@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}</style>
      <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 500px', minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>🔒 Kişisel Verilerin Korunması (KVKK)</div>
          <div style={{ fontSize: 13, color: '#d1d5db', lineHeight: 1.55 }}>
            Siber Atölye Staj Platformu olarak; kayıt sırasında paylaştığınız kimlik, iletişim, eğitim, beceri,
            sertifika ve CV bilgilerinizi staj eşleştirme hizmetinin sunulması amacıyla <strong>6698 sayılı KVKK</strong> kapsamında işliyoruz.
            Verileriniz yalnızca başvurduğunuz şirketle paylaşılır, üçüncü taraflara satılmaz.
            {readMore && (
              <div style={{ marginTop: 8 }}>
                <strong>Haklarınız:</strong> İstediğiniz zaman <em>Profil → Verilerim</em> menüsünden tüm verilerinizi JSON olarak indirebilir
                veya hesabınızı tamamen silebilirsiniz. Veri silme talebi geri alınamaz.
                Detaylı bilgi için: <a href="mailto:kvkk@siberatolye.com" style={{ color: '#93c5fd' }}>kvkk@siberatolye.com</a>
              </div>
            )}
            <button onClick={() => setReadMore(v => !v)} style={{ background: 'none', border: 'none', color: '#93c5fd', cursor: 'pointer', fontSize: 12, padding: 0, marginTop: 6, textDecoration: 'underline' }}>
              {readMore ? 'Daha az göster' : 'Devamını oku'}
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={accept} style={{
            padding: '10px 22px', background: '#16a34a', color: '#fff', border: 'none',
            borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap'
          }}>✓ Kabul Ediyorum</button>
        </div>
      </div>
    </div>
  );
};

export default KVKKBanner;
